import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Nav from "./Nav.jsx";
import Footer from "./Footer.jsx";
import "./home.css";
import "./Sales.css";
import StandardPageMain from "../Components/StandardCardMain.jsx";
import useFetch from "../Components/UseFetch.jsx";
import { companyDefault, fixedAssets } from "../HelperFx/datalinks.js";

const REACT_UNAME = process.env.REACT_APP_API_USERNAME;
const REACT_PWD = process.env.REACT_APP_API_PASSWORD;
const REACT_DATA_URL = process.env.REACT_APP_API_DATA_URL;

const CustomerInventory = () => {
  const location = useLocation();
  const token = btoa(`${REACT_UNAME}:${REACT_PWD}`);
  const docNo = location.state?.number || "";
  const [header, setHeader] = useState({});

  const headerUrl = docNo
    ? `${REACT_DATA_URL}${fixedAssets}?${companyDefault}&$filter=no eq '${docNo}'`
    : null;
  const { data: headerResponse } = useFetch(
    headerUrl || `${REACT_DATA_URL}${fixedAssets}?${companyDefault}&$top=0`,
    token,
  );

  useEffect(() => {
    const record = headerResponse?.value?.[0];
    if (record) setHeader(record);
  }, [headerResponse]);

  const fields = [
    { name: "no", label: "Asset No.", type: "text", disabled: true },
    {
      name: "fAClassCode",
      label: "Asset Class Code",
      type: "text",
      disabled: true,
    },
    {
      name: "fASubclassCode",
      label: "Asset Subclass Code",
      type: "text",
      disabled: true,
    },
    { name: "description", label: "Description", type: "text", disabled: true },
    {
      name: "serialNumber",
      label: "Serial Number",
      type: "text",
      disabled: true,
    },
    { name: "engraveNo", label: "Engrave Number", type: "text", disabled: true },
    {
      name: "faLocation",
      label: "Fixed Asset Location",
      type: "text",
      disabled: true,
    },
    { name: "manufacturer", label: "Manufacturer", type: "text", disabled: true },
    { name: "model", label: "Model", type: "text", disabled: true },
    {
      name: "bookValue",
      label: "Book Value",
      type: "decimal",
      format: "amount",
      disabled: true,
    },
    { name: "riskLevel", label: "Risk Level", type: "text", disabled: true },
    {
      name: "riskLevelDescription",
      label: "Risk Level Description",
      type: "text",
      disabled: true,
    },
    { name: "areaOfUse", label: "Area of Usage", type: "text", disabled: true },
    {
      name: "areaOfUsageDescription",
      label: "Area of Usage Description",
      type: "text",
      disabled: true,
    },
  ];

  if (!docNo) {
    return (
      <div className="Home">
        <Nav />
        <div className="dash-main settings-full">
          <div className="squote">
            <div className="firsttab px-4">Customer Inventory</div>
            <p style={{ padding: 20 }}>No inventory number was provided.</p>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="Home">
      <Nav />
      <div className="dash-main settings-full">
        <div className="squote">
          <div className="firsttab px-4">Customer Inventory {docNo}</div>
          <div className="listTable">
            <StandardPageMain
              title={`Customer Inventory - ${docNo}`}
              fields={fields}
              initialData={header}
              actions={[]}
              redirectTo="CustomerInventoryList"
              PreventEdit
              authToken={token}
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CustomerInventory;
